import { IPromise } from 'angular';
import { call, put, select } from 'redux-saga/effects';
import * as _ from 'underscore';

import { Messages } from '../../../../codegen/Localize';
import { IDataSourceBase } from '../../../../ts/models/IDataSourceInfo';
import {
  IWorkbookBase,
} from '../../../../ts/models/IWorkbookInfo';
import { Set } from '../../../../ts/models/Set';
import { IResult } from '../../../../ts/ServerApi/types/IResponse';
import {
  CreateExtractTasksAction,
} from '../../../../ts/services/CreateExtractTasksAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { CreateExtractsAction } from '../../../actions/spaces/RunCreateExtractsAction';
import { ServiceLocator } from '../../../ServiceLocator';
import { getDatasourceInfos, getWorkbookInfos } from '../SpacesSagaHelpers';


export function createExtractsForWorkbook(
  workbooks: Set<IWorkbookBase>
): IPromise<IResult> {
  const createExtractModule = ServiceLocator.get<CreateExtractTasksAction>('CreateExtractTasksAction');
  const context = ServiceLocator.getAngularActionContext();
  return createExtractModule.createExtractsForWorkbooks(workbooks, context);
}

export function createExtractsForDatasource(
  datasources: Set<IDataSourceBase>
): IPromise<IResult> {
  const createExtractModule = ServiceLocator.get<CreateExtractTasksAction>('CreateExtractTasksAction');
  const context = ServiceLocator.getAngularActionContext();
  return createExtractModule.createExtractsForDatasources(datasources, context);
}

export function* handleCreateExtractsAction(action: CreateExtractsAction) {
  const localizedErrorMessage = Messages.unexpectedError();
  try {
    const contentDictionaryByType = _.groupBy(action.selectedContent, c => c.contentType);
    if (contentDictionaryByType['workbook']) {
      const workbookInfos = yield call(getWorkbookInfos, contentDictionaryByType['workbook']);
      const workbookSet = Set.fromIdItemArray(workbookInfos);
      yield call(createExtractsForWorkbook, workbookSet);
    }
    if (contentDictionaryByType['datasource']) {
      const datasourceInfos = yield call(getDatasourceInfos, contentDictionaryByType['datasource']);
      const datasourceSet = Set.fromIdItemArray(datasourceInfos);
      yield call(createExtractsForDatasource, datasourceSet);
    }
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, localizedErrorMessage));
  }
}
